/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import template from '@bingads-webui-campaign-legacy/budget/template/budget.pug';
import ViewModel from '@bingads-webui-campaign-legacy/budget/viewmodel/budget';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as _getSuggestion from '@bingads-webui-campaign-legacy/budget/shared/getBudgetBidSuggestion';
import * as _logger from '@bingads-webui-campaign-legacy/budget/shared/log';
import * as _weeklyToMonthly from '@bingads-webui-campaign-legacy/budget/shared/weeklyToMonthly';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var getBudgetSuggestion = _getSuggestion.getBudgetSuggestion;
var logBudgetView = _logger.logBudgetView;
var weekly2MonthlyInt = _weeklyToMonthly.weekly2MonthlyInt;
function formatAdGroupClickList(adGroupClickList) {
  return _.map(adGroupClickList, weekly2MonthlyInt);
}
function sumAdGroupClickList(adGroupClickList) {
  return _.reduce(formatAdGroupClickList(adGroupClickList), function (memo, num) {
    return memo + num;
  }, 0);
}
var View = Backbone.View.extend({
  initialize: function (options) {
    options = options || ({});
    this.options = options;
    this.ko_model = new ViewModel({
      budget: this.model,
      showBudgetMinRecommend: this.options.showBudgetMinRecommend,
      minimumBudget: this.options.minimumBudget ? this.options.minimumBudget.toFixed(2) : undefined,
      showBudgetTypeSelection: this.options.showBudgetTypeSelection,
      allowBudgetTypeSelection: this.options.allowBudgetTypeSelection,
      accountCurrencyCode: pageContext.AccountCurrencyCode,
      activityLogger: this.options.activityLogger,
      hideDailyBudgetOptions: this.options.hideDailyBudgetOptions,
      validationDailyMinBudget: this.options.validationDailyMinBudget,
      currencySymbol: this.options.currencySymbol,
      readOnly: this.options.readOnly,
    });
    this.initBudget = options.initBudget;
    this.haveBudgetSuggestion = options.haveBudgetSuggestion;
    this.languages = options.languages;
    this.campaignId = options.campaignId;
    this.activity = options.activity;
    this.isForVNext = options.isForVNext;
    this.isDailyStandardName = _.uniqueId('isDailyStandard_');
  },
  events: {
    'click .expander-dailyType': 'toggleDailyType',
    'click .use-suggested-budget': 'useSuggestedBudget',
    'change input.budget-amount': 'budgetChanged',
    'click .apply-budget': 'applySuggestedBudget',
    'change input.budget-type': 'budgetTypeChanged'
  },
  render: function () {
    this.$el.html(template({
      i18n: i18n,
      accountCurrencyCode: pageContext.AccountCurrencyCode,
      minimumBudget: this.options.minimumBudget ? this.options.minimumBudget.toFixed(2) : 'undefined',
      currencySymbol: this.options.currencySymbol || '',
      isForVNext: this.isForVNext,
      isDailyStandardName: this.isDailyStandardName
    }));
    this.ko_model.budget.subscribe((function (val) {
      if (!this.ko_model.budgetInvalid()) {
        this.trigger('budget.updated', val);
      }
      this.triggerChangeEvent();
    }).bind(this));
    this.ko_model.budgetType.subscribe((function (val) {
      this.triggerChangeEvent();
    }).bind(this));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  validate: function () {
    var valid = _.isEmpty(this.ko_model.budgetError());
    var isValid = this.ko_model.validate() && valid;
    if (!isValid) {
      if (this.options.activityLogger) {
        this.options.activityLogger.signal('budget is not valid', 'budget');
      }
    }
    return isValid;
  },
  triggerChangeEvent: function () {
    if (this.options.withRealTimeUpdates) {
      this.trigger('change', this.ko_model.toObject(), !this.ko_model.budgetInvalid());
    }
  },
  update: function (model) {
    this.ko_model.update(model);
  },
  toggleDailyType: function () {
    this.ko_model.isDailyBudgetExpanded(!this.ko_model.isDailyBudgetExpanded());
    this.$('#AdvancedBudgetOptions').toggleClass('displayNone');
  },
  useSuggestedBudget: function () {
    this.ko_model.useSuggestedBudget();
  },
  applySuggestedBudget: function () {
    this.ko_model.applySuggestedBudget();
  },
  budgetChanged: function () {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal('budget change', 'budget');
    }
  },
  budgetTypeChanged: function () {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal('budget type change', 'budgetType');
    }
  },
  getValues: function () {
    return this.ko_model.toObject();
  },
  enough: function () {
    return this.ko_model.enough();
  },
  getSuggestedBudget: function () {
    return this.ko_model.suggestedBudget();
  },
  updateSuggestedBudget: function (adGroups, fromBudgetUpdate) {
    var self = this;
    fromBudgetUpdate = !!fromBudgetUpdate;
    if (!this.validate()) {
      self.ko_model.updateSuggestedBudget(0, 0);
    } else if (this.haveBudgetSuggestion && adGroups.length > 0 && !(fromBudgetUpdate && self.ko_model.Amount() >= self.ko_model.suggestedBudget())) {
      getBudgetSuggestion({
        locations: jsdata.Intermediate.getAll('CampaignCriterion'),
        adGroup: adGroups,
        budget: this.ko_model.budget(),
        initBudget: this.initBudget,
        languages: this.languages
      }, {
        onSuccess: function (data) {
          if (data && data.value && data.value.length) {
            var clicksAsSuggestedBudget = sumAdGroupClickList(data.value[0].EstimatedAdGroupClicksAsSuggestedBudget);
            var clicksAsCurrentBudget = sumAdGroupClickList(data.value[0].EstimatedAdGroupClicksAsCurrentBudget);
            var EstimatedAmountAsSuggestedBudget = data.value[0].EstimatedAmountAsSuggestedBudget;
            var clicksIncrease = clicksAsSuggestedBudget - clicksAsCurrentBudget;
            var suggestedBudget = Math.ceil(EstimatedAmountAsSuggestedBudget.Amount);
            self.ko_model.updateSuggestedBudget(suggestedBudget, clicksIncrease);
            if (self.ko_model.showSuggestedBudget()) {
              logBudgetView({
                Id: self.campaignId,
                suggestedBudget: self.ko_model.suggestedBudget(),
                initBudget: self.initBudget,
                budget: self.ko_model.budget()
              }, self.activity);
            }
          } else {
            self.ko_model.updateSuggestedBudget(0, 0);
          }
        },
        onRequestError: function () {
          self.ko_model.updateSuggestedBudget(0, 0);
        }
      }, {});
    }
  }
});
export default View;
